<template>
	<div class="tg-page-root lg-page" :class="languageClass">
		<div class="header-section">
			<div class="header-visual">
				<img src="@/assets/img/le_logo.png" class="logo" mode="heightFix">
			</div>
		</div>
		<!-- 主要内容区域 -->
		<div class="main-content">
			<img src="@/assets/img/le_asset_17.png" class="footer-deco-img" mode="widthFix">
			
			<div class="top-info">
				<div class="text1">LeSIM</div>
				<div class="text2" v-html="$t('Lg_Coverage_Title')"></div>
				<div class="text3">
					<div class="bg" v-html="$t('Lg_Coverage_Desc')"></div>
				</div>
				<div class="text4" v-html="$t('Lg_Platform_Registration')"></div>
				<div class="text5" v-html="$t('Lg_Cross_Border')"></div>
				<div class="text6" v-html="$t('Lg_Payment_Method')"></div>
				
				<div class="text7">
					<span class="dot">●</span>
					<span v-html="$t('Lg_Feature_1')"></span>
				</div>
				<div class="text8">
					<span class="dot">●</span>
					<span v-html="$t('Lg_Feature_2')"></span>
				</div>
				<div class="text9">
					<span class="dot">●</span>
					<span v-html="$t('Lg_Feature_3')"></span>
				</div>
			</div>
			
			<div class="step">
				<div class="name" v-html="$t('Lg_Steps_Title')"></div>
				<div class="step-info">
					<div class="num">01</div>
					<div class="text" v-html="$t('Lg_Step_1')"></div>
				</div>
				<div class="arrow">
					<img src="@/assets/img/lg-arrow.png" class="img" mode="widthFix">
				</div>
				<div class="step-info">
					<div class="num">02</div>
					<div class="text" v-html="$t('Lg_Step_2')"></div>
				</div>
				<div class="arrow">
					<img src="@/assets/img/lg-arrow.png" class="img" mode="widthFix">
				</div>
				<div class="step-info">
					<div class="num">03</div>
					<div class="text" v-html="$t('Lg_Step_3')"></div>
				</div>
			</div>
			
			<div class="invite">
				<div class="text1" v-html="$t('Lg_Invite_Text_1')"></div>
				<div class="text2" v-html="$t('Lg_Invite_Text_2')"></div>
				<div class="invite-img">
					<img src="@/assets/img/lg-img-2.png" class="img" mode="widthFix">
				</div>
				<div class="text3" v-html="$t('Lg_Invite_Text_3')"></div>
				<div class="text4" v-html="$t('Lg_Invite_Text_4')"></div>
			</div>
		</div>
		<div class="fvk-popup">
			<div class="fvk-wrap-box">
				<div class="popup-title" v-html="$t('Lg_Register_Title')">
				</div>
				<div class="fvk-popup-wrap">
					<div class="form-container">
						<div class="input-group">
							<input class="input-field" type="text" :placeholder="$t('Lg_Email_Placeholder')" :focus="false" v-model="email" @input="focusInputPop"/>
						</div>
						<TurnstileWidget
							v-if="!codeSent"
							ref="sendCodeTurnstileRef"
							@success="onSendCodeTurnstileSuccess"
							@expired="onSendCodeTurnstileExpired"
						/>
						<div class="input-group password-group">
							<input class="input-field" type="text" :placeholder="$t('Lg_Verify_Code_Placeholder')" :focus="false" v-model="verifyCode" @input="focusInputPop1"/>
							<button v-if="!codeSent" @click="sendVerificationCode" :disabled="codeLoading || sendCodeTurnstilePending" class="input-btn">
								<span v-if="codeLoading" v-html="$t('Lg_Sending_Code')"></span>
								<span v-else v-html="$t('Lg_Get_Code')"></span>
							</button>
							<span v-else class="code-sent-text" v-html="$t('Lg_Code_Sent')"></span>
						</div>
						<div class="input-group">
							<input class="input-field" type="password" :placeholder="$t('Lg_Password_Placeholder')" :focus="false" v-model="password" @input="focusInputPop2"/>
						</div>
						<div class="input-group">
							<input class="input-field" type="password" :placeholder="$t('Lg_Confirm_Password_Placeholder')" v-model="confirmPassword" />
						</div>
						<!-- 邀请码区域 -->
						<div class="invite-code-section">
							<span class="invite-label" v-html="$t('Lg_Invite_Code_Label')"></span>
							<input :disabled="inviteDisable" v-model="inviteCode" class="invite-code" :class="{min: inviteCode === '', disabled: inviteDisable}" type="text" :placeholder="$t('Lg_Invite_Code_Placeholder')">
							<div class="copy-btn" @click="copyInviteCode" v-if="inviteDisable">
								<span v-html="$t('Lg_Copy')"></span>
							</div>
							<div class="copy-btn hide" v-if="!inviteDisable">
								<div class="gap">
								</div>
							</div>
						</div>
						<!-- 协议勾选 -->
						<!-- <div class="agreement-section">
							<u-checkbox-group v-model="agreeTerms" activeColor="#5BAE00" iconSize="16">
								<u-checkbox shape="square" name="agreeTerms" labelSize="26rpx">
								</u-checkbox>
							</u-checkbox-group>
							<span class="agreement-text" @click="changeAgreeTerm">我已閱讀並同意 <span class="link" @click="$nav.to('member/userAgreement')">服務協議</span> 與 <span class="link" @click="$nav.to('member/privacyAgreement')">隱私政策</span></span> 
						</div> -->
						<TurnstileWidget
							ref="registerTurnstileRef"
							@success="onRegisterTurnstileSuccess"
							@expired="onRegisterTurnstileExpired"
						/>
						<!-- 开通账户按钮 -->
						<div class="register-btn" :class="{ disabled: registerTurnstilePending }" @click="register">
							<span v-if="loading" v-html="$t('Lg_Registering')"></span>
							<span v-else v-html="$t('Lg_Register_Button')"></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
import { ref, onMounted, computed, inject } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { showAppNotification } from '@/utils/appNotification'
import { useI18n } from 'vue-i18n'
import { setStorage } from '@/utils/storage'
import { STORAGE_KEYS } from '@/constants/storageKeys'
import { getReferrerCodeFromQuery } from '@/utils/referrerFromQuery'
import logger from '@/utils/logger'
import { trackSignUp } from '@/tracking'
import TurnstileWidget from '@/components/TurnstileWidget.vue'

const { t, locale } = useI18n()
const router = useRouter()
const route = useRoute()
const api = inject('api')

// Computed property to add 'en' class when language is English
const languageClass = computed(() => {
  return locale.value === 'en' ? 'en' : ''
})

const email = ref('')
const verifyCode = ref('')
const password = ref('')
const confirmPassword = ref('')
const inviteCode = ref('')
const inviteDisable = ref(false)
const loading = ref(false)
const codeSent = ref(false)
const codeLoading = ref(false)

const sendCodeTurnstileRef = ref(null)
const registerTurnstileRef = ref(null)
const sendCodeTurnstileToken = ref('')
const registerTurnstileToken = ref('')
const turnstileEnabled = !!process.env.VUE_APP_TURNSTILE_SITE_KEY
const sendCodeTurnstilePending = ref(turnstileEnabled)
const registerTurnstilePending = ref(turnstileEnabled)

const onSendCodeTurnstileSuccess = (token) => {
	sendCodeTurnstileToken.value = token
	sendCodeTurnstilePending.value = false
}

const onSendCodeTurnstileExpired = () => {
	sendCodeTurnstileToken.value = ''
	sendCodeTurnstilePending.value = true
}

const onRegisterTurnstileSuccess = (token) => {
	registerTurnstileToken.value = token
	registerTurnstilePending.value = false
}

const onRegisterTurnstileExpired = () => {
	registerTurnstileToken.value = ''
	registerTurnstilePending.value = true
}

// 设置 App Source 为 lesim-lg (在 setup 顶层执行，确保在 API 请求前生效)
setStorage(STORAGE_KEYS.APP_SOURCE, 'lesim-lg')

onMounted(() => {
	const code = getReferrerCodeFromQuery(route.query)
	if (code) {
		inviteCode.value = code
		inviteDisable.value = true
	}
})

const focusInputPop = () => {
	// 输入框聚焦处理
}

const focusInputPop1 = () => {
	// 输入框聚焦处理
}

const focusInputPop2 = () => {
	// 输入框聚焦处理
}

const copyInviteCode = () => {
	if (navigator.clipboard) {
		navigator.clipboard.writeText(inviteCode.value).then(() => {
			showAppNotification({
				message: t('Lg_Invite_Code_Copied'),
				type: 'success',
				duration: 2000,
				position: 'bottom-right'
			})
		}).catch(err => {
			logger.error('复制失败:', err)
		})
	} else {
		// 降级方案
		const textArea = document.createElement('textarea')
		textArea.value = inviteCode.value
		document.body.appendChild(textArea)
		textArea.focus()
		textArea.select()
		try {
			document.execCommand('copy')
			showAppNotification({
				message: t('Lg_Invite_Code_Copied'),
				type: 'success',
				duration: 2000,
				position: 'bottom-right'
			})
		} catch (err) {
			logger.error('复制失败:', err)
		}
		document.body.removeChild(textArea)
	}
}

// 发送验证码
const sendVerificationCode = async () => {
	logger.debug('sendVerificationCode')
	if (!email.value) {
		showAppNotification({
			message: t('Lg_Email_Required'),
			type: 'error',
			duration: 2000,
			position: 'bottom-right'
		})
		return
	}
	
	// 邮箱格式验证
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	if (!emailRegex.test(email.value)) {
		showAppNotification({
			message: t('Lg_Email_Invalid'),
			type: 'error',
			duration: 2000,
			position: 'bottom-right'
		})
		return
	}
	
	if (turnstileEnabled && !sendCodeTurnstileToken.value) {
		showAppNotification({
			message: t('Register_Turnstile_Required'),
			type: 'warning',
			duration: 2000,
			position: 'bottom-right'
		})
		return
	}

	codeLoading.value = true
	try {
		const response = await api.auth.sendRegisterCode(email.value, 'web', sendCodeTurnstileToken.value || null)
		
		// API 直接返回 JSONResponse，格式为 { status, data }
		if (response.data?.status === '0') {
			codeSent.value = true
			showAppNotification({
				message: t('Lg_Code_Sent'),
				type: 'success',
				duration: 2000,
				position: 'bottom-right'
			})
		} else {
			const errorMsg = response.data?.data?.error || t('Lg_Register_Failed')
			showAppNotification({
				message: errorMsg,
				type: 'error',
				duration: 2500,
				position: 'bottom-right'
			})
		}
	} catch (error) {
		// 错误已由 API 拦截器处理
		logger.error('Send code error:', error)
		sendCodeTurnstileRef.value?.reset()
		sendCodeTurnstileToken.value = ''
		sendCodeTurnstilePending.value = true
	} finally {
		codeLoading.value = false
	}
}

// 表单验证
const validateForm = () => {
	if (!email.value) {
		showAppNotification({
			message: t('Lg_Email_Required'),
			type: 'error',
			duration: 2000,
			position: 'bottom-right'
		})
		return false
	}
	
	// 邮箱格式验证
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	if (!emailRegex.test(email.value)) {
		showAppNotification({
			message: t('Lg_Email_Invalid'),
			type: 'error',
			duration: 2000,
			position: 'bottom-right'
		})
		return false
	}
	
	if (!verifyCode.value) {
		showAppNotification({
			message: t('Lg_Verify_Code_Required'),
			type: 'error',
			duration: 2000,
			position: 'bottom-right'
		})
		return false
	}
	
	if (!password.value) {
		showAppNotification({
			message: t('Lg_Password_Required'),
			type: 'error',
			duration: 2000,
			position: 'bottom-right'
		})
		return false
	}
	
	if (password.value.length < 6) {
		showAppNotification({
			message: t('Lg_Password_Min_Length'),
			type: 'error',
			duration: 2000,
			position: 'bottom-right'
		})
		return false
	}
	
	if (!confirmPassword.value) {
		showAppNotification({
			message: t('Lg_Confirm_Password_Required'),
			type: 'error',
			duration: 2000,
			position: 'bottom-right'
		})
		return false
	}
	
	if (password.value !== confirmPassword.value) {
		showAppNotification({
			message: t('Lg_Password_Mismatch'),
			type: 'error',
			duration: 2000,
			position: 'bottom-right'
		})
		return false
	}
	
	return true
}

const register = async () => {
	// 表单验证
	if (!validateForm()) {
		return
	}

	if (turnstileEnabled && !registerTurnstileToken.value) {
		showAppNotification({
			message: t('Register_Turnstile_Required'),
			type: 'warning',
			duration: 2000,
			position: 'bottom-right'
		})
		return
	}
	
	if (loading.value || registerTurnstilePending.value) {
		return
	}
	
	loading.value = true
	
	try {
		const response = await api.auth.register({
			Email: email.value,
			Password: password.value,
			Username: '', // lg页面没有用户名字段
			VerificationCode: verifyCode.value,
			ReferrerCode: inviteCode.value || undefined,
			ReceivePromotionalEmails: true // lg页面默认接收推广邮件
		}, registerTurnstileToken.value || null)
		
		// 处理响应格式：API 返回的是 { content: { status, data } }
		const responseData = response.data?.content || response.data
		
		if (responseData?.status === '0' && responseData?.data?.access_token) {
			// 保存 token
			setStorage(STORAGE_KEYS.TOKEN, responseData.data.access_token)
			
			// GTM: 注册成功事件
			trackSignUp(email.value, 'email')
			
			showAppNotification({
				message: t('Lg_Register_Success'),
				type: 'success',
				duration: 2000,
				position: 'bottom-right'
			})

			// 跳转到首页
			setTimeout(() => {
				router.push('/')
			}, 1500)
		} else {
			const errorMsg = responseData?.data?.error || t('Lg_Register_Failed')
			showAppNotification({
				message: errorMsg,
				type: 'error',
				duration: 2500,
				position: 'bottom-right'
			})
		}
	} catch (error) {
		// 错误已由 API 拦截器处理
		logger.error('Register error:', error)
		registerTurnstileRef.value?.reset()
		registerTurnstileToken.value = ''
		registerTurnstilePending.value = true
		showAppNotification({
			message: t('Lg_Network_Error'),
			type: 'error',
			duration: 2500,
			position: 'bottom-right'
		})
	} finally {
		loading.value = false
	}
}
</script>


<style lang="scss">
.lg-page {
	width: 100%;
	min-height: 100vh;
	background-color: #FFFFFF;
	position: relative;
	overflow-x: hidden;
	font-family: Arial;
	@media screen and (min-width: 768px) {
		width: 375px;
		max-width: 375px;
			margin: 0 auto;
	}
	
	&.en {
		.main-content .invite {
			.text3 {
				font-size: 50rpx;
			}
			.text4 {
				font-size: 34rpx;
			}
		}
	}
	
	.header-section {
		position: relative;
		overflow: visible; // Allow SIMs to float out if needed
		margin-bottom: 20rpx;
	
		.header-visual {
			position: relative;
			display: flex;
			position: relative;
			.logo {
				width: 175rpx;
				height: 61rpx;
				margin: 60rpx 0 0 40rpx;
			}
	
		}
	}
	
	.main-content {
		text-align: center;
		padding: 50rpx 0 0 0;
		position: relative;
		.footer-deco-img {
			position: absolute;
			right: 0;
			top: 0;
			width: 150rpx;
			height: 130rpx;
			z-index: 1;
		}
		.top-info {
			text-align: left;
			background-image: url('@/assets/img/lg-img-1.png');
			background-size: 100% 1102rpx;
			background-repeat: no-repeat;
			background-position: center bottom;
			padding: 0 0rpx 0 60rpx;
			.text1 {
				font-weight: bold;
				font-size: 100rpx;
				color: #04CF73;
				line-height: 100rpx;
			}
			.text2 {
				font-weight: bold;
				font-size: 100rpx;
				color: #FFAE00;
				line-height: 100rpx;
			}
			.text3 {
				font-weight: bold;
				font-size: 28rpx;
				color: #FFFFFF;
				line-height: 52rpx;
				display: flex;
				margin-top: 20rpx;
				margin-right: 60rpx;
				.bg {
					background: #04CF73;
					padding: 0 14rpx;
					border-radius: 4rpx;
				}
			}
			.text4 {
				font-weight: 400;
				font-size: 26rpx;
				color: #444444;
				line-height: 38rpx;
				margin-top: 30rpx;
				margin-right: 60rpx;
				.bold {
					font-weight: bold;
					color: #04CF73;
				}
			}
			.text5 {
				font-weight: 400;
				font-size: 26rpx;
				color: #444444;
				margin-top: 10rpx;
				margin-right: 60rpx;
				.bold {
					font-weight: bold;
					color: #04CF73;
				}
			}
			.text6 {
				font-weight: 400;
				font-size: 31rpx;
				color: #444444;
				margin-top: 10rpx;
				margin-right: 60rpx;
				.bold {
					font-weight: bold;
					color: #FFAE00;
				}
			}
			.text9 {
				margin-bottom: 60rpx;
			}
			.text7, .text8, .text9 {
				display: flex;
				font-weight: 400;
				font-size: 34rpx;
				color: #444444;
				line-height: 63rpx;
				margin-right: 60rpx;
				.dot {
					color: #04CF73;
					margin-right: 10rpx;
				}
				.bold {
					font-weight: bold;
					color: #FFAE00;
					margin: 0 6rpx;
				}
			}
			.text7 {
				margin-top: 790rpx;
			}
		}
		
		.step {
			margin: 0 66rpx 80rpx 66rpx;
			.name {
				font-size: 42rpx;
				color: #444444;
				margin-bottom: 20rpx;
				font-weight: bold;
				display: flex;
				align-items: center;
				justify-content: center;
				.bold {
					font-size: 70rpx;
					color: #FFAE00;
					margin: 0 6rpx;
					transform: translateY(-2px);
				}
			}
			.step-info {
				display: flex;
				height: 120rpx;
				background: rgba(255,255,255,0.7);
				border-radius: 26rpx;
				border: 1px solid #BEBEBE;
				position: relative;
				text-align: center;
				line-height: 120rpx;
				justify-content: center;
				margin: 0 26rpx;
				.num {
					width: 80rpx;
					height: 80rpx;
					line-height: 80rpx;
					background: #04CF73;
					border-radius: 20rpx;
					font-family: DIN Black;
					font-weight: 400;
					font-size: 48rpx;
					color: #FFFFFF;
					position: absolute;
					left: 20rpx;
					top: 20rpx;
				}
				.text {
					font-weight: bold;
					font-size: 38rpx;
					color: #04CF73;
				}
			}
			.arrow {
				margin: 26rpx;
				display: flex;
				justify-content: center;
				.img {
					width: 36rpx;
					height: 24rpx;
				}
			}
		}
		
		.invite {
			text-align: center;
			margin: 0 60rpx 90rpx 60rpx;
			.text1 {
				font-weight: 400;
				font-size: 32rpx;
				color: #444444;
			}
			.text2 {
				font-weight: bold;
				font-size: 40rpx;
				color: #F7AC00;
				.num {
					font-size: 50rpx;
				}
			}
			.invite-img {
				display: flex;
				justify-content: center;
				margin-top: 70rpx;
				.img {
					width: 540rpx;
					height: 434rpx;
				}
			}
			.text3 {
				font-weight: bold;
				font-size: 60rpx;
				color: #04CF73;
				.bold {
					color: #F7AC00;
				}
			}
			.text4 {
				font-weight: 400;
				font-size: 40rpx;
				color: #444444;
			}
		}
	}
	
	.fvk-popup {
		margin: 0 40rpx 116rpx 40rpx;
		.fvk-wrap-box {
			width: 100%;
			height: 100%;
			background: #DBFFE8;
			border-radius: 60rpx;
			
		}
		.popup-title {
			font-family: Microsoft YaHei;
			font-weight: bold;
			font-size: 34rpx;
			color: #000000;
			padding: 50rpx 50rpx 50rpx 50rpx;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			.bold {
				color: #F7AC00;
				font-size: 44rpx;
				margin-left: 6rpx;
			}
		}
		.fvk-popup-top {
			padding: 0 60rpx 0 60rpx;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			.popup-right-btn {
				height: 80rpx;
				display: flex;
				align-items: center;
				
				.txt {
					font-family: PingFang SC;
					font-weight: 500;
					font-size: 24rpx;
					color: #000000;
					margin-right: 14rpx;
				}
				.arrow-icon {
					width: 25rpx;
					height: 15rpx;
					transition: transform 0.3s ease;
					&.rotated {
						transform: rotate(180deg);
					}
				}
			}
		}
		.fvk-popup-wrap {
			transition: all 0.5s ease-in-out; /* 高度变化动画 */
			padding: 0 42rpx 55rpx 42rpx;
			box-sizing: border-box;
		}
	}
	
	.form-container {
		.input-group {
			margin-bottom: 24rpx;
			position: relative;
			.input-field {
				transition: all 0.3s ease-in-out; /* 高度变化动画 */
				height: 99rpx;
				border: 1rpx solid #DBDBDB;
				border-radius: 45rpx;
				width: 100%;
				padding: 0 48rpx;
				font-size: 28rpx;
				color: #333;
				box-sizing: border-box;
				font-family: PingFang SC;
				font-weight: 500;
				font-weight: normal;
				outline: none;
				.uni-input-placeholder {
					color: #ACACAC;
				}
			}
			
			&.password-group {
				display: flex;
				align-items: center;
				background: #ffffff;
				border-radius: 50rpx;
				position: relative;
				.input-field {
					padding-right: 180rpx;
				}
				
				.getCode {
					position: absolute;
					right: 0;
					z-index: 0;
					font-weight: bold;
					font-weight: normal;
					font-size: 28rpx;
					color: #00D06D;
					padding: 0 50rpx 0 30rpx;
				}
				
				.input-btn {
					position: absolute;
					right: 0;
					z-index: 0;
					font-weight: bold;
					font-size: 28rpx;
					color: #00D06D;
					padding: 0 50rpx 0 30rpx;
					background: none;
					border: none;
					cursor: pointer;
					&:disabled {
						opacity: 0.5;
						cursor: not-allowed;
					}
				}
				
				.code-sent-text {
					position: absolute;
					right: 0;
					z-index: 0;
					font-weight: normal;
					font-size: 24rpx;
					color: #999;
					padding: 0 50rpx 0 30rpx;
				}
			}
		}
		
		.invite-code-section {
			display: flex;
			align-items: center;
			background: #ffffff;
			border-radius: 45rpx;
			padding: 0 24rpx 0 32rpx;
			height: 99rpx;
			margin-bottom: 46rpx;
			width: 100%;
			overflow: hidden;
			
			.invite-label {
				font-size: 28rpx;
				color: #000;
				margin-right: 20rpx;
				font-family: PingFang SC;
				font-weight: 500;
				font-weight: normal;
				white-space: nowrap;
			}
			
			.invite-code {
				font-family: PingFang SC;
				font-weight: bold;
				font-size: 36rpx;
				color: #000000;
				text-align: left;
				flex: 1;
				min-width: 0;
				width: auto;
				border: none;
				background: transparent;
				padding-right: 12rpx;
				outline: none;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				.uni-input-placeholder {
					color: #ACACAC;
					font-weight: normal;
				}
				&.min {
					font-size: 28rpx;
				}
				&.disabled {
					width: auto;
					margin-left: 0;
				}
			}
			
			.copy-btn {
				flex: 0 0 auto;
				padding: 0 8rpx;
				height: 90rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: bold;
				font-size: 28rpx;
				color: #00D06D;
				white-space: nowrap;
				.imgcs {
					width: 32rpx;
					height: 32rpx;
				}
				.gap {
					width: 0rpx;
				}
				&.hide {
					padding: 0 20rpx;
				}
			}
		}
		
		.agreement-section {
			display: flex;
			align-items: center;
			margin-bottom: 70rpx;
			margin-left: 16rpx;
			.link {
				color: #00D06D;
			}
			.checkbox {
				margin-right: 10rpx;
				width: 28rpx;
				height: 28rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: -2rpx;
				::v-deep .uni-checkbox-wrapper {
					.uni-checkbox-input {
						width: 28rpx;
						height: 28rpx;
					}
				}
			}
			::v-deep .u-checkbox__icon-wrap {
				margin-right: 14rpx;
				border-color: #5BAE00 !important;
			}
			
			.agreement-text {
				font-family: PingFang SC;
				font-weight: 500;
				font-weight: normal;
				font-size: 26rpx;
				color: #000000;
				.link {
					color: #00D06D;
					margin: 0 6rpx;
					font-weight: 500;
					text-decoration: underline;
				}
			}
		}
		
		.register-btn {
			background: #00D06D;
			border-radius: 45rpx;
			text-align: center;
			height: 99rpx;
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: PingFang SC;
			font-weight: 400;
			font-size: 30rpx;
			color: #FFFFFF;
			.icon {
				width: 44rpx;
				height: 40rpx;
				margin-left: 10rpx;
			}
		}
	}
}
</style>